import { render, staticRenderFns } from "./TokenMelhorEnvio.vue?vue&type=template&id=4a1896fe&scoped=true"
import script from "./TokenMelhorEnvio.vue?vue&type=script&lang=js"
export * from "./TokenMelhorEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1896fe",
  null
  
)

export default component.exports